export default __webpack_public_path__ + "static/media/Strangler's Wristbands of Malice.8f475f9c.jpg";